import styled from '@emotion/styled'
import { PLATFORM_MODE_COLORS, PLATFORM_MODE_LABELS, PlatformMode } from 'constants/platformMode'
import { usePlatformMode } from 'hooks/usePlatformMode'

const Pill = styled.button<{ color: string }>`
  position: fixed;
  right: 12px;
  bottom: 12px;
  z-index: 2000;
  padding: 4px 12px;
  border: none;
  border-radius: 0.25rem;
  background: ${({ color }) => color};
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  box-shadow: 0 0 1px rgb(0 0 0 / 13%), 0 1px 3px rgb(0 0 0 / 20%);

  &:hover {
    filter: brightness(1.1);
  }
`

export const PlatformModeToggle = () => {
  const { mode, isIRhythmMode, setMode } = usePlatformMode()
  const nextMode = isIRhythmMode ? PlatformMode.TestSmarter : PlatformMode.IRhythm

  return (
    <Pill
      type="button"
      color={PLATFORM_MODE_COLORS[mode]}
      title={`Switch to ${PLATFORM_MODE_LABELS[nextMode]} mode`}
      onClick={() => setMode(nextMode)}>
      {PLATFORM_MODE_LABELS[mode]} mode
    </Pill>
  )
}
